export enum AddressFlow {
  'MultiNoGas' = 'MultiNoGas',
  'SingleNoGas' = 'SingleNoGas',
  'Multi' = 'Multi',
  'Single' = 'Single',
  'OutOfService' = 'OutOfService',
  'AddressNotFound' = 'AddressNotFound',
  'AddressNotFoundRequestNMI' = 'AddressNotFoundRequestNMI',
}

/**
 * Australian state abbreviations.
 */
export enum State {
  NSW = 'NSW',
  QLD = 'QLD',
  SA = 'SA',
  VIC = 'VIC',
  ACT = 'ACT',
  WA = 'WA',
  NT = 'NT',
  TAS = 'TAS',
}

export enum FlatType {
  Antenna = 'ANT',
  Apartment = 'APT',
  AutomatedTellerMachine = 'ATM',
  Barbeque = 'BBQ',
  Block = 'BLCK',
  Boatshed = 'BTSD',
  Building = 'BLDG',
  Bungalow = 'BNGW',
  Cage = 'CAGE',
  Carpark = 'CARP',
  Carspace = 'CARS',
  Club = 'CLUB',
  Coolroom = 'COOL',
  Cottage = 'CTGE',
  Duplex = 'DUP',
  Factory = 'FY',
  Flat = 'F',
  Garage = 'GRGE',
  Hall = 'HALL',
  House = 'HSE',
  Kiosk = 'KSK',
  Lease = 'LSE',
  Lobby = 'LBBY',
  Loft = 'LOFT',
  Lot = 'LOT',
  Maisonette = 'MSNT',
  MarineBerth = 'MB',
  Office = 'OFF',
  Penthouse = 'PTHS',
  Rear = 'REAR',
  Reserve = 'RESV',
  Room = 'RM',
  Section = 'SEC',
  Shed = 'SHED',
  Shop = 'SHOP',
  Showroom = 'SHRM',
  Sign = 'SIGN',
  Site = 'SITE',
  Stall = 'SL',
  Store = 'STOR',
  StrataUnit = 'STR',
  Studio = 'STU',
  Substation = 'SUBS',
  Suite = 'SE',
  Tenancy = 'TNCY',
  Tower = 'TWR',
  Townhouse = 'TNHS',
  Unit = 'U',
  Vault = 'VLT',
  Villa = 'VLLA',
  Ward = 'WARD',
  Warehouse = 'WE',
  Workshop = 'WKSH',
}

export enum FloorType {
  Basement = 'B',
  Floor = 'FL',
  Ground = 'G',
  Level = 'L',
  Lobby = 'LB',
  LowerGround = 'LG',
  Mezzanine = 'M',
  ObservationDeck = 'OD',
  Parking = 'P',
  Rooftop = 'RT',
  Sub = 'SB',
  UpperGround = 'UG',
}

export enum StreetType {
  Access = 'ACCS',
  Acre = 'ACRE',
  Alley = 'ALLY',
  Alleyway = 'ALWY',
  Amble = 'AMBL',
  Anchorage = 'ANCG',
  Approach = 'APP',
  Arcade = 'ARC',
  Artery = 'ART',
  Arterial = 'ARTL',
  Avenue = 'AVE',
  Banan = 'BA',
  Bank = 'BANK',
  Basin = 'BASN',
  Bay = 'BAY',
  Beach = 'BCH',
  Bridge = 'BDGE',
  Broadway = 'BDWY',
  Bend = 'BEND',
  Block = 'BLK',
  Bowl = 'BOWL',
  Brae = 'BRAE',
  Branch = 'BRAN',
  Brace = 'BRCE',
  Brett = 'BRET',
  Break = 'BRK',
  Brow = 'BROW',
  Boulevard = 'BVD',
  Boulevarde = 'BVDE',
  Boardwalk = 'BWLK',
  Bypass = 'BYPA',
  Byway = 'BYWY',
  Causeway = 'CAUS',
  Circuit = 'CCT',
  CulDeSac = 'CDS',
  Chase = 'CH',
  Circle = 'CIR',
  Close = 'CL',
  Colonnade = 'CLDE',
  Cluster = 'CLR',
  Circlet = 'CLT',
  Common = 'CMMN',
  Concord = 'CNCD',
  Connection = 'CNN',
  Corner = 'CNR',
  Centreway = 'CNWY',
  Concourse = 'CON',
  Cove = 'COVE',
  Crossway = 'COWY',
  Copse = 'CPS',
  Circus = 'CRCS',
  Crossroad = 'CRD',
  Crescent = 'CRES',
  Crief = 'CRF',
  Crook = 'CRK',
  Course = 'CRSE',
  Crossing = 'CRSG',
  Cross = 'CRSS',
  Crest = 'CRST',
  Corso = 'CSO',
  Court = 'CT',
  Centre = 'CTR',
  Cutting = 'CTTG',
  Courtyard = 'CTYD',
  Cut = 'CUT',
  Cruiseway = 'CUWY',
  Dale = 'DALE',
  Dash = 'DASH',
  Dell = 'DELL',
  Dene = 'DENE',
  Deviation = 'DEVN',
  Dip = 'DIP',
  Divide = 'DIV',
  Dock = 'DOCK',
  Domain = 'DOM',
  Down = 'DOWN',
  Drive = 'DR',
  Driveway = 'DRWY',
  Distributor = 'DSTR',
  Downs = 'DWNS',
  Edge = 'EDGE',
  Elbow = 'ELB',
  End = 'END',
  Entrance = 'ENT',
  Easement = 'ESMT',
  Esplanade = 'ESP',
  Estate = 'EST',
  Expressway = 'EXP',
  Extension = 'EXTN',
  Fairway = 'FAWY',
  Firebreak = 'FBRK',
  Firetrail = 'FITR',
  Fork = 'FK',
  Flat = 'FLAT',
  Fireline = 'FLNE',
  Flats = 'FLTS',
  Follow = 'FOLW',
  Ford = 'FORD',
  Formation = 'FORM',
  Front = 'FRNT',
  Frontage = 'FRTG',
  Foreshore = 'FSHR',
  Firetrack = 'FTRK',
  Footway = 'FTWY',
  Freeway = 'FWY',
  Gap = 'GAP',
  Garden = 'GDN',
  Gardens = 'GDNS',
  Glade = 'GLD',
  Glen = 'GLEN',
  Gully = 'GLY',
  Grove = 'GR',
  Grange = 'GRA',
  Green = 'GRN',
  Ground = 'GRND',
  Gate = 'GTE',
  Gates = 'GTES',
  Gateway = 'GTWY',
  Heath = 'HETH',
  Hill = 'HILL',
  Hollow = 'HLLW',
  Harbour = 'HRBR',
  Highroad = 'HRD',
  Heights = 'HTS',
  Hub = 'HUB',
  Haven = 'HVN',
  Highway = 'HWY',
  Inlet = 'INLT',
  Interchange = 'INTG',
  Intersection = 'INTN',
  Island = 'ISLD',
  Junction = 'JNC',
  Key = 'KEY',
  Keys = 'KEYS',
  Knoll = 'KNOL',
  Ladder = 'LADR',
  Lane = 'LANE',
  Landing = 'LDG',
  Lead = 'LEAD',
  Leader = 'LEDR',
  Lees = 'LEES',
  Line = 'LINE',
  Link = 'LINK',
  Lookout = 'LKT',
  Laneway = 'LNWY',
  Loop = 'LOOP',
  Little = 'LT',
  Lower = 'LWR',
  Lynne = 'LYNN',
  Mall = 'MALL',
  Manor = 'MANR',
  Mart = 'MART',
  Mead = 'MEAD',
  Mew = 'MEW',
  Mews = 'MEWS',
  Mile = 'MILE',
  Meander = 'MNDR',
  Mount = 'MT',
  Motorway = 'MWY',
  Nook = 'NOOK',
  North = 'NTH',
  Null = 'NULL',
  Outlook = 'OTLK',
  Outlet = 'OTLT',
  Oval = 'OVAL',
  Park = 'PARK',
  Part = 'PART',
  Pass = 'PASS',
  Path = 'PATH',
  Parade = 'PDE',
  Pathway = 'PHWY',
  Piazza = 'PIAZ',
  Parklands = 'PKLD',
  Pocket = 'PKT',
  Parkway = 'PKWY',
  Place = 'PL',
  Plateau = 'PLAT',
  Palms = 'PLMS',
  Plaza = 'PLZA',
  Point = 'PNT',
  Port = 'PORT',
  Paradise = 'PRDS',
  Precinct = 'PREC',
  Promenade = 'PROM',
  Pursuit = 'PRST',
  Passage = 'PSGE',
  Peninsula = 'PSLA',
  Quadrangle = 'QDGL',
  Quadrant = 'QDRT',
  Quad = 'QUAD',
  Quay = 'QY',
  Quays = 'QYS',
  Ramp = 'RAMP',
  Reach = 'RCH',
  Road = 'RD',
  Ridge = 'RDGE',
  Roads = 'RDS',
  Roadside = 'RDSD',
  Roadway = 'RDWY',
  Reef = 'REEF',
  Reserve = 'RES',
  Rest = 'REST',
  Ridgeway = 'RGWY',
  Ride = 'RIDE',
  Ring = 'RING',
  Rise = 'RISE',
  Ramble = 'RMBL',
  Round = 'RND',
  Ronde = 'RNDE',
  Range = 'RNGE',
  Row = 'ROW',
  Rowe = 'ROWE',
  Right = 'ROWY',
  Rosebowl = 'RSBL',
  Rising = 'RSNG',
  Route = 'RTE',
  Return = 'RTRN',
  Retreat = 'RTT',
  Rotary = 'RTY',
  Rue = 'RUE',
  Run = 'RUN',
  River = 'RVR',
  Riviera = 'RVRA',
  Riverway = 'RVWY',
  Subway = 'SBWY',
  Siding = 'SDNG',
  Shunt = 'SHUN',
  StateStreet = 'SHWY',
  Skyline = 'SKLN',
  Slope = 'SLPE',
  Sound = 'SND',
  Spur = 'SPUR',
  Square = 'SQ',
  Street = 'ST',
  Strait = 'STAI',
  South = 'STH',
  Steps = 'STPS',
  Strand = 'STRA',
  Strip = 'STRP',
  Stairs = 'STRS',
  Straight = 'STRT',
  ServiceWay = 'SWY',
  Tarn = 'TARN',
  Terrace = 'TCE',
  Thoroughfare = 'THOR',
  Throughway = 'THRU',
  Trunkway = 'TKWY',
  Tollway = 'TLWY',
  Tramway = 'TMWY',
  Top = 'TOP',
  Tor = 'TOR',
  Triangle = 'TRI',
  Track = 'TRK',
  Trail = 'TRL',
  Trailer = 'TRLR',
  Tunnel = 'TUNL',
  Turn = 'TURN',
  Traverse = 'TVSE',
  Towers = 'TWRS',
  Underpass = 'UPAS',
  Upper = 'UPR',
  Vale = 'VALE',
  Viaduct = 'VDCT',
  View = 'VIEW',
  Village = 'VLGE',
  Villa = 'VLL',
  Villas = 'VLLS',
  Valley = 'VLLY',
  Vista = 'VSTA',
  Vue = 'VUE',
  Views = 'VWS',
  Wade = 'WADE',
  Walk = 'WALK',
  Way = 'WAY',
  Woods = 'WDS',
  Wharf = 'WHRF',
  Walkway = 'WKWY',
  Wood = 'WOOD',
  Waters = 'WTRS',
  Waterway = 'WTWY',
  Wynd = 'WYND',
  Yard = 'YARD',
}

export enum StreetSuffix {
  CENTRAL = 'CN',
  DEVIATION = 'DE',
  EAST = 'E',
  EXTENSION = 'EX',
  INNER = 'IN',
  LOWER = 'LR',
  MALL = 'ML',
  NORTH = 'N',
  NORTHEAST = 'NE',
  NORTHWEST = 'NW',
  OFF = 'OF',
  ON = 'ON',
  OVERPASS = 'OP',
  OUTER = 'OT',
  SOUTH = 'S',
  SOUTHEAST = 'SE',
  SOUTHWEST = 'SW',
  UPPER = 'UP',
  WEST = 'W',
}
